import Component from '@glimmer/component';
import { eq } from 'ember-truth-helpers';
import HotelTooltipsTooltipRateRoomtype from 'lumen/components/hotel/tooltips/tooltip-rate-roomtype';

interface ParityTooltipsTooltipParityOverviewTableSignature {
  Args: {
    formattedRate: unknown;
    issue: unknown;
    message: unknown;
  };
}

export default class ParityTooltipsTooltipParityOverviewTable extends Component<ParityTooltipsTooltipParityOverviewTableSignature> {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get hasRate() {
    // @ts-expect-error: Incorrect type
    return this.args.issue?.value !== 0;
  }

  <template>
    {{#unless (eq @message "general.missing")}}
      <HotelTooltipsTooltipRateRoomtype
        {{! @glint-expect-error: Incorrect type }}
        @extractDatetime={{@issue.extractDatetime}}
        @fetchOtherLosRates={{false}}
        @forceShowUpdateTime={{true}}
        {{! @glint-expect-error: Incorrect type }}
        @formattedRateOverride={{@formattedRate}}
        @hasRate={{this.hasRate}}
        {{! @glint-expect-error: Incorrect type }}
        @roomNameOverride={{@issue.roomName}}
        {{! @glint-expect-error: Incorrect type }}
        class="rates-table-tooltip"
      />
    {{/unless}}
  </template>
}
